export default __webpack_public_path__ + "static/media/Homemadelogo.72aca280.png";